import { render, staticRenderFns } from "./StackCardList.vue?vue&type=template&id=b219e666&scoped=true&"
import script from "./StackCardList.vue?vue&type=script&lang=js&"
export * from "./StackCardList.vue?vue&type=script&lang=js&"
import style0 from "./StackCardList.vue?vue&type=style&index=0&id=b219e666&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b219e666",
  null
  
)

export default component.exports